import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  IconButton
} from '@mui/material'
import {
  Close as CloseIcon
} from '@mui/icons-material'
import { ActionButton } from '@emerald-works-nova/components'
import { useStyles } from './edit-page-name-modal-style'

const EditPageNameModal = ({ open, page, onClose, onSave }) => {
  const classes = useStyles()
  const [pageName, setPageName] = useState('')
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (open && page) {
      setPageName(page.name || '')
      setErrors({})
    }
  }, [open, page])

  const handleInputChange = (value) => {
    setPageName(value)
    // Clear errors when user starts typing
    if (errors.name) {
      setErrors(prev => ({ ...prev, name: null }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!pageName.trim()) {
      newErrors.name = 'Page name is required'
    }

    if (pageName.trim().length > 100) {
      newErrors.name = 'Page name must be 100 characters or less'
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSave = () => {
    if (validateForm()) {
      onSave({
        ...page,
        name: pageName.trim()
      })
      handleClose()
    }
  }

  const handleClose = () => {
    setPageName('')
    setErrors({})
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth='sm'
      fullWidth
      className={classes.dialog}
      data-test='edit-page-name-modal'
    >
      <DialogTitle className={classes.dialogTitle}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography variant='h6' className={classes.title}>
            Edit Page Name
          </Typography>
          <IconButton onClick={handleClose} size='small'>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant='body2' color='textSecondary' className={classes.subtitle}>
          Update the name of your page. This will be displayed in the navigation and page header.
        </Typography>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <TextField
          fullWidth
          label='Page Name'
          value={pageName}
          onChange={(e) => handleInputChange(e.target.value)}
          error={!!errors.name}
          helperText={errors.name}
          placeholder='Enter page name'
          data-test='page-name-input'
          className={classes.formField}
          autoFocus
        />
      </DialogContent>

      <DialogActions className={classes.dialogActions}>
        <ActionButton
          variant='secondary'
          onClick={handleClose}
          dataTest='cancel-edit-page-name'
        >
          Cancel
        </ActionButton>
        <ActionButton
          variant='primary'
          onClick={handleSave}
          dataTest='save-page-name'
        >
          Save Changes
        </ActionButton>
      </DialogActions>
    </Dialog>
  )
}

export default EditPageNameModal
